export default "__VITE_ASSET__yUq8f7n3__"